import { Box } from '@mui/material';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import SessionContext from '../../contexts/session';
import { activeFormId, redirectUserAfterLogin } from '../../logic/auth';
import useAppUserAgent from '../core/use-app-user-agent';
import { FeatureEnum } from '../../utils/users/featureAccess.enum';
import { userHasAccess } from '../../utils/users/user-utils';

const withAuthentication = (WrappedComponent, feature?: FeatureEnum) => {
    const RequiresAuthentication = props => {
        const [cookies] = useCookies();
        const [hasAccess, setHasAccess] = useState(false);
        const { user, initialized } = useContext(SessionContext);
        const appUserAgent = useAppUserAgent();
        const router = useRouter();
        useEffect(() => {
            if (initialized) {
                const inApp = cookies?.ss_app === 'true' || appUserAgent?.isApp;
                if (!user.id) {
                    router.push(
                        '/login/phone?redirectUrl=' + (window
                            ? encodeURIComponent(window.location.toString())
                            : '')
                    );
                } else if (feature && !userHasAccess(user, feature)) {
                    router.push('/dashboard');
                } else if (user.diagnosticInFlight || !user.phoneAuthorized || inApp) {
                    redirectUserAfterLogin(
                        user, router, undefined, user?.formId || activeFormId, setHasAccess, cookies, appUserAgent
                    );
                } else {
                    setHasAccess(true);
                }
            }
        }, [user, initialized]);
        return user.id && hasAccess ? <WrappedComponent {...props} /> : <Box />;
    };
    return RequiresAuthentication;
};

export default withAuthentication;
